/*
 *
 * Whitelisting constants
 *
 */

// Constants
import * as hourGlassAnimationData from 'animation/hour-glass.json';

export const BASE_ACTION_CONSTANT = 'app/RateLimits';
export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;
export const ENABLE_LOADER_ACTION = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER_ACTION`;
export const DISABLE_LOADER_ACTION = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER_ACTION`;

export const DOMAIN_REF = 'domain_name';
export const PACKAGE_REF = 'android_package';

export const TYPE_DROPDOWN_OPTIONS = [
  { key: '0', value: DOMAIN_REF, text: 'Website URL' },
  { key: '1', value: PACKAGE_REF, text: 'App Link' },
];

export const GET_WHITELISTING_DATA = `${BASE_ACTION_CONSTANT}/GET_WHITELISTING_DATA`;
export const GET_WHITELISTING_URL = '/pg/merchant-domain-app-info';

export const FETCH_WHITELISTING_DETAILS = `${BASE_ACTION_CONSTANT}/FETCH_WHITELISTING_DETAILS`;
export const POST_WHITELISTING_DATA = `${BASE_ACTION_CONSTANT}/POST_WHITELISTING_DATA`;
export const UPDATE_WHITELISTING_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_WHITELISTING_DATA`;
export const GET_LIVENESS_DATA = `${BASE_ACTION_CONSTANT}/GET_LIVENESS_DATA`;

export const POST_WHITELISTING_URL = {
  url: '/pg/merchant-request-new-domain',
  method: 'POST',
};

export const PL_BULK_UPLOAD = 'pl_bulk_upload';

export const SHARE_LOGIN_DETAILS_PLACEHOLDER = `Example
Username: rahul@mycompany.com
Password/OTP: mycompany.123`;

export const WEBSITE_POLICIES = [
  'Contact Us.',
  'Terms & Conditions.',
  'Refunds & Cancellations.',
];

export const OTHER_DETAILS = [
  'Products/services should be listed.',
  'Products/services pricing should be in INR.',
];

export enum MODALS {
  INACTIVE_DOMAIN = 'INACTIVE_DOMAIN',
  ADD_TO_WHITELIST = 'ADD_TO_WHITELIST',
  REVIEW_DOMAIN = 'REVIEW_DOMAIN',
  REVIEW_APP = 'REVIEW_APP',
  APPROVED_DOMAIN = 'APPROVED_DOMAIN',
  APPROVED_APP = 'APPROVED_APP',
}

export enum PAGES {
  WHITELISTING = 'WHITELISTING',
  FIX_ERROR = 'FIX_ERROR',
}

export enum LOADERS {
  PAGE_LOADER = 'PAGE_LOADER',
  MODAL_LOADER = 'MODAL_LOADER',
}

export enum WHITELISTING_STATUS {
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  IN_REVIEW = 'IN_REVIEW',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  ACTION_PENDING = 'ACTION_PENDING',
}

export enum TEST_IDS {
  ADD_TO_WHITELIST_MODAL = 'ADD_TO_WHITELIST_MODAL',
  INACTIVE_WEBSITE_MODAL = 'INACTIVE_WEBSITE_MODAL',
  REVIEW_MODAL = 'REVIEW_MODAL',
  WHITELIST_STEP_ONE = 'WHITELIST_STEP_ONE',
  WHITELIST_STEP_TWO = 'WHITELIST_STEP_TWO',
  BACK_BUTTON = 'BACK_BUTTON',
}

export const hourGlassAnimationOptions = {
  loop: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  animationData: hourGlassAnimationData,
};

export const EMPTY_DROPDOWN_STATE = {
  refType: '',
  refName: '',
};

export const WHITELIST_INITIAL_FORM_DATA = {
  channelValue: '',
  loginAvailable: false,
  testCredentials: '',
};

export const INACTIVE_WEBSITE_INITIAL_FORM_DATA = {
  reason: '',
};

export const REJECTION_STATUSES: string[] = [
  WHITELISTING_STATUS.REJECTED,
  WHITELISTING_STATUS.ACTION_PENDING,
];

export enum DOMAIN_TYPE {
  WEBSITE = 'WEBSITE',
  APP = 'APP',
}

export const CONTENT_TYPE_JSON_HEADER = {
  'Content-type': 'application/json',
};
